import Vue from "vue";

Vue.filter("rate", (value) => Math.round(value * 100) / 100);



// WEBPACK FOOTER //
// ./_common/filters/rate.filter.js